module.exports = __webpack_public_path__ + "img/noData.f9b3b6d8.png";